"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsHeaderWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var PaymentSessionExpiredPopupWidget_1 = require("./PaymentSessionExpiredPopupWidget");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var reactstrap_1 = require("reactstrap");
var commonFunctions_1 = require("../../commonFunctions");
var PaymentsHeaderWidget = exports.PaymentsHeaderWidget = /** @class */ (function (_super) {
    __extends(PaymentsHeaderWidget, _super);
    function PaymentsHeaderWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelectOnChangeEvent = function (event) {
            var selectedValue = event.target.value;
            if (selectedValue === "Visa Debit" || selectedValue === "Mastercard Debit") {
                _this.setState({
                    selectedCardTypeValue: selectedValue,
                    showCardTypeWarning: false,
                    cardTypeSelected: true,
                    cardTypeErrorVisible: false
                });
            }
            else {
                _this.setState({
                    selectedCardTypeValue: "",
                    showCardTypeWarning: true,
                    cardTypeSelected: false,
                    cardTypeErrorVisible: true
                });
            }
        };
        _this.renderCardTypeValues = function () {
            var elements = [];
            elements.push(React.createElement("option", { disabled: true, selected: true, value: "" }, "Please select"));
            elements.push(React.createElement("option", { selected: false, value: "Visa Debit" }, "Visa Debit"));
            elements.push(React.createElement("option", { selected: false, value: "Visa Credit" }, "Visa Credit"));
            elements.push(React.createElement("option", { selected: false, value: "Mastercard Debit" }, "Mastercard Debit"));
            elements.push(React.createElement("option", { selected: false, value: "Mastercard Credit" }, "Mastercard Credit"));
            elements.push(React.createElement("option", { selected: false, value: "American Express" }, "American Express"));
            elements.push(React.createElement("option", { selected: false, value: "Prepaid card" }, "Prepaid card"));
            return elements;
        };
        _this.toggleCardTypeWarning = function () {
            _this.setState({ showCardTypeWarning: !_this.state.showCardTypeWarning });
        };
        _this.state = {
            addressConfirmationErrorVisible: false,
            addressConfirmed: false,
            paymentDayChosen: false,
            paymentDayChosenErrorVisible: false,
            paymentDayBannerVisible: false,
            lookupValues: [],
            cardStorageConsent: false,
            showCardTypeWarning: false,
            cardTypeSelected: false,
            cardTypeErrorVisible: false,
            selectedCardTypeValue: "",
            isBillingAddressChangeAllowed: false,
        };
        _this.onAddressConfirmChange = _this.onAddressConfirmChange.bind(_this);
        _this.blockerClick = _this.blockerClick.bind(_this);
        _this.handlePaymentDateChange = _this.handlePaymentDateChange.bind(_this);
        _this.handleOnBlur = _this.handleOnBlur.bind(_this);
        _this.onCardStorageConsentChange = _this.onCardStorageConsentChange.bind(_this);
        return _this;
    }
    PaymentsHeaderWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction)) {
            this.lookupService.fetchLookupValues("monthlyPaymentDates", "en-UK").subscribe(function (lookupValues) {
                _this.setState({
                    lookupValues: lookupValues || []
                });
            });
        }
        if (this.props.interaction.agreeToReuseCardDetails) {
            this.setState({
                cardStorageConsent: this.props.interaction.agreeToReuseCardDetails
            });
        }
        if (this.props.interaction.process === services_1.INTERACTION_PROCESS_NB) {
            var policyData = services_1.productHelper.getInteractionPolicyData(this.props.interaction);
            var isBillingAddressChangeAllowed = policyData && policyData.paymentAddressChangeAllowed === "Y";
            this.setState({ isBillingAddressChangeAllowed: isBillingAddressChangeAllowed });
        }
        else {
            this.customerPortalService.getPartyPropertyByPropertyKey(services_1.PartyPropertyEnum.BILLING_ADDRESS_CHANGE_ALLOWED)
                .subscribe(function (partyProperty) {
                _this.setState({
                    isBillingAddressChangeAllowed: partyProperty.value === "true"
                });
            });
        }
    };
    PaymentsHeaderWidget.prototype.render = function () {
        var address = this.props.engine.getInteraction() &&
            this.props.engine.getInteraction().policyHolder &&
            this.props.engine.getInteraction().policyHolder.address;
        if (this.props.interaction.paymentDetails && this.props.interaction.paymentDetails.iframeUrl) {
            return (React.createElement("div", { className: "panel p-0 pb-3 payment-header-wdg" },
                this.renderDirectDebitDepositWording(),
                React.createElement("div", { className: "row no-gutters payment-header-row secure-payment-header" },
                    React.createElement("h3", null, "Your payment is secure")),
                React.createElement("div", { className: "row no-gutters payment-header-row secure-payment-body" },
                    React.createElement("p", null, "We use Verified by Visa and MasterCard SecureCode to make sure your payment details are protected."),
                    React.createElement("div", { className: "card-icon-wrapper" },
                        React.createElement("img", { className: "visa-icon", alt: "visa-icon", src: "/img/visa-icon.svg" }),
                        React.createElement("img", { className: "mastercard-icon", alt: "mastercard-icon", src: "/img/mastercard-icon.svg" }))),
                React.createElement("div", { className: "row no-gutters payment-header-row" },
                    React.createElement("div", { className: "col-12" },
                        !this.state.isBillingAddressChangeAllowed &&
                            React.createElement(React.Fragment, null,
                                address && (React.createElement(React.Fragment, null,
                                    React.createElement("b", null, "You told us that your Allianz account holder address is:"),
                                    React.createElement("div", { id: "address-display", className: "my-2" },
                                        React.createElement("div", { id: "address-line-1" }, [address.subBuildingName, address.buildingName].filter(function (x) { return x; }).join(" ")),
                                        React.createElement("div", { id: "address-line-2" }, [address.buildingNumber, address.dependentThoroughfareName, address.dependentThoroughfareDescriptor, address.thoroughfareName, address.thoroughfareDescriptor].filter(function (x) { return x; }).join(" ")),
                                        React.createElement("div", { id: "address-line-3" }, [address.doubleDependentLocality, address.dependentLocality, address.postTown].filter(function (x) { return x; }).join(" ")),
                                        React.createElement("div", { id: "address-line-4" }, [address.outwardPostcode, address.inwardPostcode].filter(function (x) { return x; }).join(" "))))),
                                !services_1.productHelper.isDirectDebit(this.props.interaction) && this.renderAlertBox()),
                        React.createElement("div", { className: "falcon-checkbox form-group mt-3" },
                            !this.state.isBillingAddressChangeAllowed && (React.createElement("div", { className: "d-flex" },
                                React.createElement("div", { className: "form-check mr-3" },
                                    React.createElement("input", { className: "custom-control-input true", onChange: this.onAddressConfirmChange, type: "checkbox", "aria-label": "I confirm that my card is registered to the above address", name: window.name, id: "payment-address-confirm", defaultChecked: this.state.addressConfirmed }),
                                    React.createElement("label", { className: "custom-control-label", htmlFor: "payment-address-confirm" },
                                        React.createElement("div", { className: "checkbox-big" }),
                                        React.createElement("div", { className: "checkbox-label" },
                                            React.createElement("p", { className: "font-weight-semi-bold" }, "I confirm that my card is registered to the above address")))))),
                            this.state.addressConfirmationErrorVisible && (React.createElement("div", { className: "row no-gutters payment-header-row invalid-feedback d-block", role: "alert" }, "To proceed you must confirm")),
                            services_1.productHelper.isHomeOrWolfMotor(this.props.interaction)
                                /* don't display "Save card" check box on MTA and MTC payment screens */
                                && this.props.interaction.status !== services_1.INTERACTION_STATUS_PENDING_CANCELLATION
                                &&
                                    React.createElement("div", { className: "d-flex" },
                                        React.createElement("div", { className: "form-check mr-3" },
                                            React.createElement("input", { className: "custom-control-input true", onChange: this.onCardStorageConsentChange, type: "checkbox", "aria-label": "I consent to my card details being stored securely for any future policy changes I make", name: window.name, id: "storage-consent-confirm", onBlur: this.handleOnBlur, defaultChecked: this.state.cardStorageConsent }),
                                            React.createElement("label", { className: "custom-control-label", htmlFor: "storage-consent-confirm" },
                                                React.createElement("div", { className: "checkbox-big" }),
                                                React.createElement("div", { className: "checkbox-label" },
                                                    React.createElement("p", { className: "font-weight-semi-bold" }, "I consent to my card details being stored securely for any future policy changes I make.")))))),
                        this.renderAddressWording())),
                services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && this.state.isBillingAddressChangeAllowed && !services_1.productHelper.isDirectDebit(this.props.interaction) && (React.createElement("div", { className: "row no-gutters payment-header-row" },
                    React.createElement("div", { className: "banner banner-warn", role: "alert" },
                        React.createElement("p", null,
                            "We can only accept payment from a ",
                            React.createElement("span", { className: "font-weight-semi-bold" }, "debit card"),
                            " which is registered to the below address.")))),
                !services_1.productHelper.isDirectDebit(this.props.interaction) && this.renderCardTypeDropbox(),
                React.createElement("div", { className: "row no-gutters inner-iframe-wrapper payment-gateway-iframe-blockable" },
                    !services_1.productHelper.isDirectDebit(this.props.interaction) &&
                        React.createElement("div", { onClick: this.blockerClick, className: "payment-gateway-iframe-blocker", style: { display: this.isInputValid() ? "none" : "block" }, role: "none", tabIndex: this.isInputValid() ? -1 : 0 }),
                    React.createElement("iframe", { id: "payment-gateway-iframe", src: this.props.interaction.paymentDetails.iframeUrl, className: "payment-iframe", frameBorder: "0", tabIndex: this.isInputValid() ? 0 : -1 })),
                React.createElement(PaymentSessionExpiredPopupWidget_1.PaymentSessionExpiredPopupWidget, null)));
        }
        else {
            return (React.createElement("div", null, "Loading..."));
        }
    };
    PaymentsHeaderWidget.prototype.isInputValid = function () {
        var isAddressValid = this.state.isBillingAddressChangeAllowed || this.state.addressConfirmed;
        var isMonthly = services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction);
        var isCardTypeSelected = isMonthly ?
            ((this.state.cardTypeSelected || this.props.interaction.status === services_1.INTERACTION_STATUS_PENDING_CANCELLATION) && isAddressValid)
            : isAddressValid;
        return isMonthly && this.props.interaction.process === "nb" ?
            isAddressValid && this.state.paymentDayChosen && this.state.cardTypeSelected :
            isCardTypeSelected;
    };
    PaymentsHeaderWidget.prototype.onAddressConfirmChange = function (event) {
        this.setState({
            addressConfirmed: event.target.checked,
            addressConfirmationErrorVisible: !event.target.checked
        });
    };
    PaymentsHeaderWidget.prototype.onCardStorageConsentChange = function (event) {
        var checked = event.target.checked;
        this.props.interaction.agreeToReuseCardDetails = checked;
        this.setState({
            cardStorageConsent: checked
        });
    };
    PaymentsHeaderWidget.prototype.renderAddressWording = function () {
        var isMonthlyDirectDebit = services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && services_1.productHelper.isDirectDebit(this.props.interaction);
        if (services_1.productHelper.isHomeOrWolfMotor(this.props.interaction)) {
            if (!services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && this.state.isBillingAddressChangeAllowed
                || isMonthlyDirectDebit) {
                return (React.createElement("p", null, this.getCardAddressWording()));
            }
            else {
                var optionalDebitCardWording = this.props.interaction.factors.premiumType === 'monthly' ?
                    'a credit card or ' : '';
                return (React.createElement("p", null,
                    "If you attempt the payment using ",
                    optionalDebitCardWording,
                    "a card registered to a different address, your funds may result in a pending transaction and your Allianz insurance cover won\u2019t be set up."));
            }
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "We can only accept payment from a card registered to this address"),
                React.createElement("p", null, "If you don't have one, please update your details with your card issuer. "),
                React.createElement("p", null, "If you attempt the payment using a card registered to a different address, your funds may result in a pending transaction and your Flow insurance subscription won\u2019t be set up.")));
        }
    };
    PaymentsHeaderWidget.prototype.blockerClick = function () {
        if (!this.state.isBillingAddressChangeAllowed && !this.state.addressConfirmed) {
            this.setState({
                addressConfirmationErrorVisible: true
            });
            document.getElementById("payment-address-confirm").scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
        if (services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && this.props.interaction.process === services_1.INTERACTION_PROCESS_NB) {
            if (!this.state.paymentDayChosen) {
                this.setState({
                    paymentDayChosenErrorVisible: true
                });
                document.getElementById("payment-day-chosen").scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
            }
        }
        if (services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && this.props.interaction.process === services_1.INTERACTION_PROCESS_NB && !this.state.cardTypeSelected) {
            this.setState({
                cardTypeErrorVisible: true
            });
            document.getElementById("card-type-select").scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest"
            });
        }
    };
    PaymentsHeaderWidget.prototype.handlePaymentDateChange = function (event) {
        var digitRegex = /^\d+$/;
        if (digitRegex.test(event.target.value)) {
            var interaction = this.props.engine.getInteraction();
            interaction.paymentDay = { day: event.target.value, currentDay: event.target.value };
            this.props.engine.callInteractionSetState(interaction);
            this.setState({
                paymentDayChosen: true,
                paymentDayChosenErrorVisible: false,
                paymentDayBannerVisible: true
            });
        }
        else {
            this.setState({
                paymentDayChosen: false,
                paymentDayChosenErrorVisible: true,
                paymentDayBannerVisible: false
            });
        }
    };
    PaymentsHeaderWidget.prototype.handleOnBlur = function (event) {
        this.executeNativeEvent(event);
    };
    PaymentsHeaderWidget.prototype.renderDirectDebitDepositWording = function () {
        if (services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && this.props.interaction.process === services_1.INTERACTION_PROCESS_NB) {
            var datesToRender_1 = [];
            this.state.lookupValues.forEach(function (v) {
                return datesToRender_1.push(React.createElement("option", { value: v.id }, v.value));
            });
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "row no-gutters payment-header-row" },
                    React.createElement("div", { className: "col-12 secure-payment-notice px-0" },
                        React.createElement("p", null,
                            "You've chosen to pay by monthly Direct Debit. We'll take your deposit of ",
                            React.createElement("span", { className: "font-weight-semi-bold" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(this.props.interaction.paymentDetails.instalmentPlan.deposit)),
                            " now and we'll store the same card for future payments.")))));
        }
        else if (services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction)) {
            return (React.createElement(React.Fragment, null, this.state.showCardTypeWarning && this.renderCardTypeWarning()));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    PaymentsHeaderWidget.prototype.renderCardTypeDropbox = function () {
        if (services_1.productHelper.isAnnualMonthlyPremiumType(this.props.interaction) && this.props.interaction.status !== services_1.INTERACTION_STATUS_PENDING_CANCELLATION) {
            return (React.createElement("div", null,
                React.createElement("div", { className: "row no-gutters payment-header-row" },
                    React.createElement("div", { className: "col-12" },
                        React.createElement("span", { className: "font-weight-bold" }, "What card type are you using for payment?")),
                    React.createElement("select", { id: "card-type-select", className: "form-control", onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, value: this.state.selectedCardTypeValue }, this.renderCardTypeValues())),
                this.state.cardTypeErrorVisible && (React.createElement("div", { className: "row no-gutters payment-header-row invalid-feedback d-block", role: "alert" }, "Please select a card type to carry on"))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    PaymentsHeaderWidget.prototype.renderAlertBox = function () {
        return (React.createElement("div", { className: "info-button-panel font-weight-light d-flex", role: "alert" },
            React.createElement("img", { className: "d-block m-0", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "warning-sign" }),
            React.createElement("div", null,
                React.createElement("p", null, "We can only accept payment from a card which is registered to this address."))));
    };
    PaymentsHeaderWidget.prototype.renderCardTypeWarning = function () {
        var closeBtn = React.createElement("button", { className: "btn-close", onClick: this.toggleCardTypeWarning });
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { className: "my-2 info-modal card-type-modal", isOpen: this.state.showCardTypeWarning, toggle: this.toggleCardTypeWarning, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleCardTypeWarning, close: closeBtn },
                    React.createElement("div", { className: "d-flex gdpr-title-format" },
                        React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flow-info.svg"), alt: "Attention", width: 20, height: 20 }),
                        React.createElement("span", { className: "ml-3 text-blue-2 fs-20 font-weight-medium" }, "We only accept debit cards"))),
                React.createElement(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light" }, "When paying for your insurance monthly we can only accept payment from a debit card. Please make sure you\u2019re using a debit card to continue."),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { className: "btn btn-primary", onClick: this.toggleCardTypeWarning }, "OK, I understand")))));
    };
    PaymentsHeaderWidget.prototype.getCardAddressWording = function () {
        return (React.createElement(React.Fragment, null, "If you attempt the payment using a card registered to a different address than the one declared below, you may find this results in either a failed or a pending transaction and your insurance won\u2019t be set up."));
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], PaymentsHeaderWidget.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], PaymentsHeaderWidget.prototype, "customerPortalService", void 0);
    return PaymentsHeaderWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=PaymentsHeaderWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/payments/PaymentsHeaderWidget.js
// module id = 3459
// module chunks = 0